import {
    ComponentManager,
    UIListener,
    DetailViewContext,
    RADEnvironmentProxy,
    openDownloadDialogFromApplicationAsync,
    ControlFactory
} from 'radpresentation.htmlclient.defaultviewextensions';


class KursunterlagenGeneratorUIListener extends UIListener
{
    public onBeforeRender(context: DetailViewContext)
    {
        super.onBeforeRender(context);

        this.hideJournalGroup(context);
    }

    public onDetailViewReady(context: DetailViewContext)
    {
        super.onDetailViewReady(context);

        context.toolBar.getElementByMethodName('Apply').isVisible(false);

        const saveButton = context.toolBar.getElementByMethodName('Save');
        saveButton.label.ergName('Download');
        const saveButtonEnabled = saveButton.isEnabled;

        const referentSetObs = context.genericObject.getObservable('Benutzer.PDO_ID');
        const newcomerSetObs = context.genericObject.getObservable('Newcomer.PDO_ID');
        const unterlagenSetObs = context.genericObject.getObservable('Kursunterlagen.PDO_ID');
     
        const isValid = this.defineComputed(() => {
            const unterlagenSet = unterlagenSetObs();
            const newcomerSet = newcomerSetObs();
            const referentSet = referentSetObs();
            
            if (!unterlagenSet)
                return false;

            if (referentSet && newcomerSet)
                return false;

            if (!referentSet && !newcomerSet)
                return false;

            return true;
        });

        isValid.sync(saveButtonEnabled);
        
        const newcomerControl = context.getUIFactory<ControlFactory>('Newcomer');
        if (newcomerControl)
            referentSetObs.sync(newcomerControl.isEnabled, (value) => !value);
        
        const referentControl = context.getUIFactory<ControlFactory>('Benutzer');
        if (referentControl)
            newcomerSetObs.sync(referentControl.isEnabled, (value) => !value);
        
        context.genericObject.isModified(false);
    }
    
    public onBeforeSave(context: DetailViewContext): boolean | JQueryDeferred<boolean> | JQueryPromise<boolean> {
        return this.fetchAndDownloadPdf(context);
    }

    private fetchAndDownloadPdf(context: DetailViewContext) {
        return RADEnvironmentProxy.getInstance().callOperationFromDVContext({
            detailViewContextID: context.id,
            operationName: 'DownloadSignedPdf',
            operationParameters: [],
            property_values: JSON.stringify({}),
            contextParameters: {},
            nestedContextName: null,
            withValidation: false
        }).then(async result => {
            if (!this.validateStatus(result))
                return false;

            if (!result.returnValue)
                return false;

            await openDownloadDialogFromApplicationAsync(result.returnValue);
            return true;
        }).promise();
    }

    private hideJournalGroup(context: DetailViewContext) {
        const journalGroup = this.getDetailViewGroups(context, false)
                                 .filter(g => g.name.endsWith('.METADATA'));
        if (journalGroup.length > 0)
        {
            this.removeDetailViewGroupDto(context, journalGroup[0].name);
        }
    }
}

ComponentManager.setUIListener('KursunterlagenGeneratorUIListener', KursunterlagenGeneratorUIListener, 'ONVHTMLViewExtension');